// @ts-nocheck

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log('🔥 FORGOT PASSWORD: Form submitted');
    console.log('🔥 FORGOT PASSWORD: Email:', email);
    console.log('🔥 FORGOT PASSWORD: Supabase client initialized:', !!supabase);
    
    if (!email) {
      console.log('❌ FORGOT PASSWORD: No email entered');
      toast.error('Please enter your email address');
      return;
    }

    setLoading(true);

    try {
      console.log('🔥 FORGOT PASSWORD: Calling edge function...');
      const { data, error } = await invokeEdgeFunction('send-password-reset', {
        body: { email }
      });

      console.log('🔥 FORGOT PASSWORD: Edge function completed');
      console.log('🔥 FORGOT PASSWORD: Response data:', data);
      console.log('🔥 FORGOT PASSWORD: Response error:', error);

      if (error) {
        console.error('❌ FORGOT PASSWORD: Error from function:', error);
        toast.error('Failed to send reset email. Please try again.');
      } else if (data?.success === false) {
        console.log('❌ FORGOT PASSWORD: Email not found:', data.error);
        toast.error(data.error || 'Email address not found in system');
      } else {
        console.log('✅ FORGOT PASSWORD: Success! Setting sent to true');
        setSent(true);
        toast.success('Password reset email sent! Check your inbox.');
      }
    } catch (error) {
      console.error('❌ FORGOT PASSWORD: Caught error:', error);
      toast.error(`Failed to send reset email: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      console.log('🔥 FORGOT PASSWORD: Finally block - setting loading to false');
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl font-bold">Check Your Email</CardTitle>
            <CardDescription>
              We've sent a password reset link to {email}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground text-center">
              Click the link in the email to reset your password. If you don't see the email, check your spam folder.
            </p>
            <div className="space-y-2">
              <Button 
                variant="outline" 
                className="w-full" 
                onClick={() => setSent(false)}
              >
                Send Another Email
              </Button>
              <Button asChild variant="ghost" className="w-full">
                <Link to="/auth/login">Back to Login</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Forgot Password</CardTitle>
          <CardDescription>
            Enter your email address and we'll send you a link to reset your password
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email Address</Label>
              <Input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            
            <Button 
              type="submit" 
              className="w-full" 
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Email'}
            </Button>
            
            <Button asChild variant="ghost" className="w-full">
              <Link to="/auth/login">Back to Login</Link>
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}